import React, { ReactNode } from 'react';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider as RadixToastProvider,
  ToastTitle,
  ToastViewport,
} from '@roger/ui-components';
import { useStore } from '../store';
import { useShallow } from 'zustand/react/shallow';

interface ToastProviderProps {
  children: ReactNode;
}

export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  const { toasts, removeToast } = useStore(
    useShallow(state => ({
      toasts: state.toasts,
      removeToast: state.removeToast,
    }))
  );

  return (
    <RadixToastProvider>
      {children}
      {toasts.map(toast => (
        <Toast
          key={toast.id}
          variant={toast.variant}
          onOpenChange={() => removeToast(toast.id)}
        >
          <div className='grid gap-1'>
            <ToastTitle>{toast.title}</ToastTitle>
            {toast.description && (
              <ToastDescription>{toast.description}</ToastDescription>
            )}
          </div>
          <ToastClose />
        </Toast>
      ))}
      <ToastViewport />
    </RadixToastProvider>
  );
};
